export default __webpack_public_path__ + "static/media/emotionalIntensity.5fcd17e6.png";